module.exports = __webpack_public_path__ + "img/Chop Shop.ae724493.png";